interface JsonApiError {
  detail?: string
  title?: string
  message?: string
  meta?: {
    message?: string
  }
}

export function extractApiErrorMessages(err: any): string[] {
  const data = err?.response?.data

  if (data != null) {
    const errors = data.errors

    if (Array.isArray(errors) && errors.length > 0) {
      const messages = errors
        .map((error: string | JsonApiError) => {
          if (typeof error === 'string') return error
          return error?.detail || error?.title || error?.meta?.message || error?.message
        })
        .filter((message): message is string => !!message)

      if (messages.length > 0) return messages
    }

    if (typeof data.error === 'string') return [data.error]
    if (typeof data.message === 'string') return [data.message]
    if (typeof data === 'string' && data.trim()) return [data]
  }

  if (typeof err?.message === 'string' && err.message.trim()) {
    return [err.message]
  }

  const status = err?.response?.status
  if (status) return [`HTTP ${status}`]

  return []
}
